import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {RouteUtils} from '@application/helper/routing/route-utils';
import {PlanningMachineCarpetRun} from '@domain/planning/carpet/planning-machine-carpet-run';
import {PlanningItem} from '@domain/planning/planning-item';
import {PlanningMachine} from '@domain/planning/planning-machine';
import {PlanningMachineRun} from '@domain/planning/planning-machine-run';
import {PlanningOrder} from '@domain/planning/planning-order';
import {PlanningMachineTuftingRun} from '@domain/planning/tufting/planning-machine-tufting-run';
import {PlanningMachineWeavingRun} from '@domain/planning/weaving/planning-machine-weaving-run';
import {AUTHENTICATION, Authentication} from '@infrastructure/http/authentication/authentication';
import {BaseComponent} from '@vdw/angular-component-library';

@Component({
  template: ``
})
export abstract class BasePlanningItemComponent extends BaseComponent {
  @Input() public machine: PlanningMachine;
  @Output() public deletePlanningItem: EventEmitter<void> = new EventEmitter<void>();
  @Output() public closePlanningItem: EventEmitter<void> = new EventEmitter<void>();
  @Output() public selectPlanningOrder: EventEmitter<number> = new EventEmitter<number>();

  private readonly router: Router;
  private readonly PATH_TO_ADD_PRODUCTION_ORDER_FOR_RUN = RouteUtils.paths.texFab.productionOrder.addProductionOrderForRun.absolutePath;
  private _planningItem: PlanningItem;

  protected previousPlanningItem: PlanningItem;
  protected planningItemSelected = new EventEmitter<PlanningItem>();

  @Input() public set planningItem(value: PlanningItem) {
    this._planningItem = value;
    this.planningItemSelected.emit(value);

    this.previousPlanningItem = this._planningItem;
  }

  public get planningItem(): PlanningItem {
    return this._planningItem;
  }

  public constructor(
    @Inject(AUTHENTICATION) protected readonly authentication: Authentication,
    router: Router
  ) {
    super();
    this.router = router;
  }

  public isPlanningItemOfTypeRun(): boolean {
    return this.planningItem instanceof PlanningMachineRun;
  }

  public isPlanningItemCarpetRun(): boolean {
    return this.planningItem instanceof PlanningMachineCarpetRun;
  }

  public isPlanningItemWeavingRun(): boolean {
    return this.planningItem instanceof PlanningMachineWeavingRun;
  }

  public isPlanningItemTuftingRun(): boolean {
    return this.planningItem instanceof PlanningMachineTuftingRun;
  }

  public delete(): void {
    this.deletePlanningItem.emit();
  }

  public close(): void {
    this.closePlanningItem.emit();
  }

  public createProductionOrderForRun(): void {
    const planningItem = this.planningItem as PlanningMachineRun;
    if (planningItem instanceof PlanningMachineCarpetRun) {
      this.router.navigate([this.PATH_TO_ADD_PRODUCTION_ORDER_FOR_RUN], {
        state: {
          runId: planningItem.id,
          machineQualityId: planningItem.machineQuality.id,
          creelId: planningItem.creel.id,
          machineId: this.machine.id,
          startRoute: RouteUtils.paths.texFab.planning.absolutePath
        }
      });
    } else if (planningItem instanceof PlanningMachineWeavingRun) {
      this.router.navigate([RouteUtils.paths.texFab.weaving.addProductionOrderForRun.absolutePath], {
        state: {
          runId: planningItem.id,
          machineId: this.machine.id,
          weaveProductId: planningItem.weaveProduct.id
        }
      });
    } else if (planningItem instanceof PlanningMachineTuftingRun) {
      this.router.navigate([RouteUtils.paths.texFab.tufting.addProductionOrderForRun.absolutePath], {
        state: {
          runId: planningItem.id,
          machineId: this.machine.id,
          tuftProductId: planningItem.tuftProduct.id
        }
      });
    }
  }

  public onPlanningOrderSelected(planningOrder: PlanningOrder): void {
    this.selectPlanningOrder.emit(planningOrder.id);
  }
}
